import type {MidiNote} from "./types";

export interface Instrument {
  name: string,
  transpose: number,
  skillLevels: SkillLevel[],
}

export interface SkillLevel {
  name: string,
  bottom: string,
  top: string
}

const instruments = [
  {
    name: "clarinet",
    transpose: -2,
    skillLevels: [
      {
        name: "beginner",
        bottom: "C4",
        top: "A5"
      },
      {
        name: "intermediate",
        bottom: "E3",
        top: "C6",
      },
      {
        name: "professional",
        bottom: "E3",
        top: "G6",
      }
    ]
  },
  {
    name: "altosax",
    transpose: -9,
    skillLevels: [
      {
        name: "beginner",
        bottom: "D4",
        top: "A5",
      },
      {
        name: "intermediate",
        bottom: "C4",
        top: "D6",
      },
      {
        name: "professional",
        bottom: "Bb3",
        top: "F#6",
      }
    ]
  }
];


export function getInstruments(): Instrument[] {
  return instruments;
}
